import React, { MouseEvent } from 'react';
import { Box, CircularProgress, IconButton } from '@mui/material';
import { isMobileOnly } from 'react-device-detect';

import Tooltip from '@core/dashboard/components/ButtonTooltip';
import { COLORS } from '@constants/colors';

import { IHomeBarButton } from './intefaces';
import { useStyles } from './styles';

const HomeBarButton = ({
  icon,
  handleClick,
  label,
  showPulseAnimation = false,
  isRed = false,
  isActive = false,
  disabled = false,
  sx = {},
  buttonSx = {},
  isLoading = false,
  loadingIndicator,
  dataTestId
}: IHomeBarButton) => {
  const classes = useStyles({
    showPulseAnimation: (showPulseAnimation || isRed) && !disabled,
  });
  const rootClass = { ...classes.root, ...sx };
  const buttonClass = {
    ...classes.button,
    ...buttonSx,
    ...(isActive ? classes.active : {}),
  };
  const animationClass = showPulseAnimation
    ? classes.pulseBox
    : isRed
    ? classes.warning
    : {};

  const onClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.currentTarget.blur();
    handleClick(event);
  };

  return (
    <Tooltip title={label}>
      <Box sx={{ ...rootClass, position: 'relative' }}>
        {!disabled ? <Box sx={animationClass} /> : null}
        <IconButton
          disabled={disabled}
          sx={buttonClass}
          onClick={onClick}
          disableRipple
          data-testid={dataTestId}
        >
          {icon}
        </IconButton>
        {isLoading && (
          <Box
            sx={{
              position: 'absolute',
              inset: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              pointerEvents: 'none',
              zIndex: 2,
            }}
          >
            {loadingIndicator || (
              <CircularProgress
                size={isMobileOnly ? 28 : 32}
                sx={{ color: COLORS.WHITE }}
              />
            )}
          </Box>
        )}
      </Box>
    </Tooltip>
  );
};

export default HomeBarButton;
